// import Swiper JS
import Swiper from 'swiper';
import {Navigation, Pagination, Scrollbar} from 'swiper/modules';

// import Swiper styles
import 'swiper/css';

window.addEventListener('load', ()=> {
    initSlider();
});

window.addEventListener('orientationchange', ()=> {
    initSlider();
})

function initSlider() {
    const wrapperSwiper = document.querySelector('.cards-big-block');

    if (wrapperSwiper) {
        const swiperElement = wrapperSwiper.querySelector('.swiper');
        // const buttonPrev = wrapperSwiper.querySelector('.swiper-button-prev');
        // const buttonNext = wrapperSwiper.querySelector('.swiper-button-next');
    
        const slider = new Swiper(swiperElement, {
            modules: [Navigation, Pagination, Scrollbar],
            slidesPerView: 1,
            spaceBetween: 15,
            observer: true,
            observeParents: true,
            // centerInsufficientSlides: true,
            // autoHeight: true,
            centeredSlides: true,
            initialSlide: 1,
            breakpoints: {
                650: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    centeredSlides: false,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
            },

            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
                // hide: true,
            },
    
            // navigation: {
            //     prevEl: buttonPrev,
            //     nextEl: buttonNext,
            // },
    
            // pagination: {
            //     el: ".swiper-pagination",
            //     // clickable: true,
            //     dynamicBullets: true,
            //     // dynamicMainBullets: 3,
            // },
        });
    
        slider;    
    }
}
